module.exports = __webpack_public_path__ + "img/chips_sprites_sheet.af627e51.png";